import { CSSProperties } from 'react';
import { CONSTANTS } from '../../UIConstants';

export const topNavBarContainer: CSSProperties = {
    display: CONSTANTS.DISPLAY.FLEX,
    alignItems: CONSTANTS.FLEX_ALIGN.CENTER,
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW,
    color: CONSTANTS.COLORS.DARK_GREY,
    height: 95,
    borderBottom: '2px solid' + CONSTANTS.COLORS.BORDER_GREY,
    fontSize: CONSTANTS.FONT_SIZE.LARGE,
    flexShrink: 0
};

const navBarTextStyles: CSSProperties = {
    fontFamily: 'sans-serif',
    fontSize: 26 + 'px',
    fontWeight: 'bold',
    color: CONSTANTS.COLORS.THEME_GREY,
};

export const titleContainer: CSSProperties = {
    ...navBarTextStyles,
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    textAlign: 'left',
    paddingLeft: 100 + 'px',
};

export const logOutContainer: CSSProperties = {
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    textAlign: 'right',
    paddingRight: 100 + 'px',
    alignItems: 'center',
    display: CONSTANTS.DISPLAY.FLEX,
    justifyContent: CONSTANTS.FLEX_JUSTIFY.END,
};

export const logOutLinkStyle: CSSProperties = {
    ...navBarTextStyles,
    textDecoration: 'none',
    fontSize: 20 + 'px',
};


export const profileImageStyle: CSSProperties = {
    height: 50 + 'px',
    width: 50 + 'px',
    borderRadius: 50 + '%',
    marginRight: 10 + 'px'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Layout/TopNavBar.ts